import styled from 'styled-components'

export const FilterButton = styled.div`
  display: inline-block;
  width: auto;
  height: 40px;
  border-radius: 4px;
  padding: 0 25px;
  margin: 0 5px 0 0;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: ${props => props.theme.colors.oxfordBlue};
  font-size: ${props => props.theme.fontSizes.filterButton};

  &:hover,
  &.active {
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.primary};
    font-family: ${props => props.theme.fonts.robotoMedium};

    svg {
      fill: ${props => props.theme.colors.white};
    }
  }

  svg {
    height: 16px;
    margin-top: 12px;
    width: 30px;
    fill: ${props => props.theme.colors.oxfordBlue};
  }
`
